import { IComputerList, IGoodsList } from '@/api/inventory';

interface IInitState {
  type: 1 | 2 | 3 | null;
  roomNo: string;
  billRoomNo: string;
  computerList: IComputerList[];
  goodsList: IGoodsList[];
  goodsListCopy: IGoodsList[];
  peripheralList: any[];

  searchText: string;
  searching: boolean;

  pageLoading: boolean;
}

export const initState: IInitState = {
  type: null,
  roomNo: '',
  billRoomNo: '',
  computerList: [],
  goodsList: [],
  goodsListCopy: [],
  peripheralList: [],

  searchText: '',
  searching: false, // 是否处于搜索状态

  pageLoading: false,
};

export const inventoryReducer = (state, action) => {
  switch (action.type) {
    case 'init':
      return {
        ...state,
        ...action.payload,
      };
    case 'update-state':
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
